export const GET_SCALES_LIST_IN_PROGRESS =
  "GET_SCALES_LIST_IN_PROGRESS";
export const GET_SCALES_LIST_SUCCESS =
  "GET_SCALES_LIST_SUCCESS";
export const GET_SCALES_LIST_FAIL = "GET_SCALES_LIST_FAIL";
export const GET_SCALE_INFOS_IN_PROGRESS =
  "GET_SCALE_INFOS_IN_PROGRESS";
export const GET_SCALE_INFOS_SUCCESS =
  "GET_SCALE_INFOS_SUCCESS";
export const GET_SCALE_INFOS_FAIL = "GET_SCALE_INFOS_FAIL";
export const POST_SCALE_IN_PROGRESS = "POST_SCALE_IN_PROGRESS";
export const POST_SCALE_SUCCESS = "POST_SCALE_SUCCESS";
export const POST_SCALE_FAIL = "POST_SCALE_FAIL";
export const PUT_SCALE_IN_PROGRESS = "PUT_SCALE_IN_PROGRESS";
export const PUT_SCALE_SUCCESS = "PUT_SCALE_SUCCESS";
export const PUT_SCALE_FAIL = "PUT_SCALE_FAIL";
export const DELETE_SCALE_IN_PROGRESS =
  "DELETE_SCALE_IN_PROGRESS";
export const DELETE_SCALE_SUCCESS = "DELETE_SCALE_SUCCESS";
export const DELETE_SCALE_FAIL = "DELETE_SCALE_FAIL";
